import cx from 'classnames'
import Image from 'next/image'

import ShoppingBagAsset from '@/assets/images/brawlstars/bs-cart-icon.png'
import { Flare } from '@/features/storefronts/_storeBase/flare/Flare'

import styles from './ShoppingBagHero.module.scss'

type Props = {
  className?: string
}

export const ShoppingBagHero = ({ className }: Props) => {
  return (
    <div className={cx(styles.ImageContainer, className)}>
      <Flare game={'brawlstars'} />
      <Image src={ShoppingBagAsset} alt="Hero image" width={343} height={184} />
    </div>
  )
}
